import tw from 'tailwind-styled-components';

export const StateDropdownContainer = tw.div`
    sm:px-10
    md:mx-auto
    md:w-[300px]
    mt-4

`;

export const StateDropdownNotAvialbleText = tw.div`
    text-primary-100
    text-center
`;

export const StateDropdownClass = `
    [&_span.react-dropdown-select-item]:text-primary-100
    hover:[&_span.react-dropdown-select-item]:bg-secondary-100
    [&_span.react-dropdown-select-item-selected]:bg-secondary-100
`;